// For Service ReportTokenUsage
import { useNuxtApp } from '#app';
import { ENUM } from '~/plugins/constants/enum';
import { BaseService } from '../base/base.service';
import {
  ModelGETReportTokenUsage,
  ModelGETReportTokenUsageId,
  ModelGETReportTokenUsageSummary,
  type IModelGETReportTokenUsageIdRequest,
  type IModelGETReportTokenUsageRequest,
  type IModelGETReportTokenUsageSummaryRequest,
} from './dto/report-token-usage.dto';

import { ReportTokenUsageRepository } from './report-token-usage.repository';

export class ReportTokenUsageService extends BaseService {
  private reportTokenUsageRepository = new ReportTokenUsageRepository(
    this.api,
    this.configService
  );

  async getReportTokenUsage(
    params: IModelGETReportTokenUsageRequest
  ): Promise<ModelGETReportTokenUsage> {
    const { $functions } = useNuxtApp();
    let dataResult: ModelGETReportTokenUsage = new ModelGETReportTokenUsage();
    try {
      const res = await this.reportTokenUsageRepository.getReportTokenUsage(
        params
      );
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelGETReportTokenUsage(resData);
        console.log('getReportTokenUsage', params, resData, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, ReportTokenUsageService.name);
    }
    return dataResult;
  }

  async getReportTokenUsageSummary(
    params: IModelGETReportTokenUsageSummaryRequest
  ): Promise<ModelGETReportTokenUsageSummary> {
    const { $functions } = useNuxtApp();
    let dataResult: ModelGETReportTokenUsageSummary =
      new ModelGETReportTokenUsageSummary();
    try {
      const res =
        await this.reportTokenUsageRepository.getReportTokenUsageSummary(
          params
        );
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelGETReportTokenUsageSummary(resData.data);
        console.log(
          'getReportTokenUsageSummary',
          params,
          resData.data,
          dataResult
        );
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, ReportTokenUsageService.name);
    }
    return dataResult;
  }

  async exportReportTokenUsageSummary(params: any): Promise<any> {
    let dataResult: any = null;
    const { $functions } = useNuxtApp();
    try {
      const res = await this.reportTokenUsageRepository.exportReportTokenUsageSummary(
        params
      );
      const resData = res.data.value;
      // if ($functions.isValidResponse(resData)) {
      if (resData) {
        dataResult = resData;
        console.log('exportReport', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, ReportTokenUsageService.name);
    }
    return dataResult;
  }

  async exportReportFeedback(params: any): Promise<any> {
    let dataResult: any = null;
    const { $functions } = useNuxtApp();
    try {
      const res = await this.reportTokenUsageRepository.exportReportFeedback(
        params
      );
      const resData = res.data.value;
      if (resData) {
        dataResult = resData;
        console.log('exportReport', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, ReportTokenUsageService.name);
    }
    return dataResult;
  }

  async getReportTokenUsageId(
    params: IModelGETReportTokenUsageIdRequest
  ): Promise<ModelGETReportTokenUsageId> {
    const { $functions } = useNuxtApp();
    let dataResult: ModelGETReportTokenUsageId =
      new ModelGETReportTokenUsageId();
    try {
      const res = await this.reportTokenUsageRepository.getReportTokenUsageId(
        params
      );
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelGETReportTokenUsageId(resData.data);
        console.log('GETReportTokenUsageId', params, resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, ReportTokenUsageService.name);
    }
    return dataResult;
  }
}
